import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons";

import { IconComponent } from "./types";

export const AnytimeIcon: IconComponent = (props) => {
  return <FontAwesomeIcon {...props} icon={faLayerGroup} color="#59A39B" />;
};
